import { SearchQuery } from './filter/SearchQuery'
import { useCategoryFilters } from './hooks/useCategoryFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const { filters, updateSearch, clearAllFilters, hasActiveFilters } =
    useCategoryFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            onSearchChange={updateSearch}
            placeholder="Buscar categoría..."
            searchQuery={filters.search}
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            handleClearFilters={handleClearFilters}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
          />
        )}
      </div>
    </div>
  )
}
